import React, { useState, useEffect } from 'react';
import { useParams, Navigate , useLocation} from 'react-router-dom';
import features from './features'; 
import '../ups_stab_subpages_styles.css';
import specs from './specs.json';

const StabilizerSubpages = () => {
  const { id } = useParams();
  const texts = features[id];
  const [tableData, setTableData] = useState([]);
  const [imageSrc, setImageSrc] = useState(null);
  const [isMobile, setIsMobile] = useState(false);

  const loadImage = async () => {
    try {
      const imageModule = await import(`../../styling/images/stabilizer/${id}.jpg`);
      return imageModule.default;
    } catch (error) {
      console.error('Error loading image:', error);
      return null;
    }
  };

  useEffect(() => {
    loadImage().then(setImageSrc);
  }, [id]);

  useEffect(() => {
    if (specs && specs[id]) {
      const data = specs[id].filter(item => item !== null);
      setTableData(data);
    } else {
      setTableData([]);
    }
  }, [id]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // Adjust this threshold as needed
    };

    // Initial check on component mount
    handleResize();

    // Listen for window resize events
    window.addEventListener('resize', handleResize);

    // Cleanup
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const location = useLocation(); // Get location state inside the component
  const { productCategory, productCap1, productCap2} = location.state || {};
  const handleSpecificationsClick = () => {
    openSpecificationsTab(tableData, productCategory, productCap1, productCap2); // Pass product name to openSpecificationsTab
  };
  const openSpecificationsTab = (tableData, productCategory, productCap1, productCap2) => {
    const specsWindow = window.open('', '_blank');
    
    if (specsWindow) {
      specsWindow.document.write('<html><head><title>Specifications</title></head><body>');
      specsWindow.document.write('<style>table {border-collapse: collapse; width: 100%;} th, td {border: 1px solid black; padding: 8px; text-align: left;}</style>');
      specsWindow.document.write(`<h1 style="font-size: 38px; text-align: center; margin-top: 20px;">${productCategory}</h1>`);
    specsWindow.document.write(`<h3  style="font-size: 36px; text-align: center; margin-top: 10px;">${productCap1} - ${productCap2}</h3>`);
      specsWindow.document.write('<h1>Specifications</h1>');
      specsWindow.document.write('<table>');
      // Write table headers
      specsWindow.document.write('<thead><tr>');
      if (tableData.length > 0) {
        Object.keys(tableData[0]).forEach(header => {
          specsWindow.document.write(`<th>${header}</th>`);
        });
      }
      specsWindow.document.write('</tr></thead>');

      // Write table body
      specsWindow.document.write('<tbody>');
      tableData.forEach(row => {
        specsWindow.document.write('<tr>');
        Object.keys(row).forEach(key => {
          if (Object.keys(row).length === 1 && key === 'Model') {
            specsWindow.document.write(`<td colSpan="${Object.keys(row).length + 10}" style="text-align: center; font-weight: bold;">${row[key]}</td>`);
          } else {
            specsWindow.document.write(`<td>${row[key] !== null ? row[key] : 'N/A'}</td>`);
          } 
        });
        specsWindow.document.write('</tr>');
      });
      specsWindow.document.write('</tbody></table></body></html>');
      specsWindow.document.close();
    } else {
      alert('Please allow pop-ups for this website to view specifications.');
    }
};


// broucher pdf
  const openPdfInNewTab = () => {
    // Replace 'path_to_your_pdf.pdf' with the actual path to your PDF file
    const pdfUrl = `/stabilizer_brouchers/${id}.pdf`;
    
    // Open the PDF in a new tab
    window.open(pdfUrl, '_blank');
  };  
  // Check if id is other than '1' and '2', then redirect to Page Not Found
  if (!(id.length === 1 && id >= '1' && id <= '5')) {
    return <Navigate to="/PageNotFound" />;
  }
  return (
    <div className='subpage'>
      {imageSrc && <img src={imageSrc} alt={`Image ${id}`} />}
    
    {/* Broucher Pdf*/}
    <button className="broucher-btn" onClick={openPdfInNewTab}>Download <br /> Broucher PDF</button>
      <h1>Features</h1>
      
      <ul>
        {texts && texts.map((text, index) => (
          <li key={index}>{text}</li>
        ))}
      </ul>

      <h1 className='specs'>Specifications</h1>
      <table className='specs'>
        <thead>
          <tr>
            {tableData.length > 0 && Object.keys(tableData[0]).map((header, index) => (
              <th key={index}>{header}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {tableData.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {Object.keys(row).map((key, cellIndex) => (
                <React.Fragment key={cellIndex}>
                  {Object.keys(row).length === 1 && key === 'Model' && (
                    <td colSpan={Object.keys(row).length + 10} style={{ textAlign: 'center', fontWeight: 'bold'}}>
                      {row[key]}
                    </td>
                  )}
                  {!(Object.keys(row).length === 1 && key === 'Model') && (
                    <td>{row[key] !== null ? row[key] : 'N/A'}</td>
                  )}
                </React.Fragment>
              ))}
            </tr>
          ))}
        </tbody>
      </table>

      {/* Specifications button on responsive screen */}
      {isMobile && <button className="specs-btn" onClick={handleSpecificationsClick}>Click Here <br/> To  View <br/> Technical Specifications</button>}
    

    </div>
  );
};

export default StabilizerSubpages;
